import { render } from "./EmailVerificationRequest.vue?vue&type=template&id=644a5461&scoped=true&ts=true"
import script from "./EmailVerificationRequest.vue?vue&type=script&lang=ts"
export * from "./EmailVerificationRequest.vue?vue&type=script&lang=ts"

import "./EmailVerificationRequest.vue?vue&type=style&index=0&id=644a5461&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644a5461"]])

export default __exports__